// React Navigation
// Path: src/Components/Navigation.js
import Hi from '../Images/Hi.png';
import React from 'react';
import { HashLink } from 'react-router-hash-link';
import styled from 'styled-components'
import { BrowserRouter } from 'react-router-dom';

import Connect from '../utils/Connect';


const Navigation = styled.div`
    // border: 1px solid white;
    display: flex;
    flex-direction: row;
    height: 6vh;
    // width: 100vw;
    font-size: calc(10px + 2vmin);
`;

// hover scale
const NavbarLink = styled(HashLink)`
    color: white;
    margin: 10px;
    &:hover,
    &:focus {
      color: palevioletred;
    }
    &:active {
        color: red;
    }
`;

const Image = styled.img`
    // height: auto;
    // width: auto;
    margin: 10px;
    max-height: 5vh;
`



export default function NAVIGATION() {




    return (
        <Navigation>
            {/* <Image src={Hi} alt="logo" />             */}
            {/* <BrowserRouter>
                <NavbarLink to="/" smooth>Home</NavbarLink>
                <NavbarLink to="#introduction" smooth>Introduction</NavbarLink>
                <NavbarLink to="#FAQ" smooth>FAQ</NavbarLink>
                <NavbarLink to="#roadmap" smooth>Roadmap</NavbarLink>
                <NavbarLink to="#team" smooth>Team</NavbarLink>
            </BrowserRouter> */}
            <Connect/>
        </Navigation>

    )
}
